import { gql } from '../../../apollo/__generated__';

export const CREATE_VOUCHER = gql(`
  mutation CreateVoucher($createVoucherInput: CreateVoucherInput!) {
    createVoucher(createVoucherInput: $createVoucherInput) {
      id
      code
      amount
    }
  }
`);
